var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaIconSquare1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.460938,
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62109 18.4609C9.62109 14.8658 9.62109 13.0682 10.4778 11.7735C10.8603 11.1953 11.3555 10.7002 11.9336 10.3176C13.2284 9.46094 15.026 9.46094 18.6211 9.46094C22.2162 9.46094 24.0138 9.46094 25.3085 10.3176C25.8867 10.7002 26.3818 11.1953 26.7644 11.7735C27.6211 13.0682 27.6211 14.8658 27.6211 18.4609C27.6211 22.0561 27.6211 23.8536 26.7644 25.1484C26.3818 25.7265 25.8867 26.2217 25.3085 26.6042C24.0138 27.4609 22.2162 27.4609 18.6211 27.4609C15.026 27.4609 13.2284 27.4609 11.9336 26.6042C11.3555 26.2217 10.8603 25.7265 10.4778 25.1484C9.62109 23.8536 9.62109 22.0561 9.62109 18.4609ZM23.2803 18.4612C23.2803 21.0345 21.1943 23.1206 18.6209 23.1206C16.0476 23.1206 13.9615 21.0345 13.9615 18.4612C13.9615 15.8878 16.0476 13.8018 18.6209 13.8018C21.1943 13.8018 23.2803 15.8878 23.2803 18.4612ZM18.6209 21.5442C20.3236 21.5442 21.7039 20.1639 21.7039 18.4612C21.7039 16.7585 20.3236 15.3782 18.6209 15.3782C16.9182 15.3782 15.5379 16.7585 15.5379 18.4612C15.5379 20.1639 16.9182 21.5442 18.6209 21.5442ZM23.4644 14.6625C24.069 14.6625 24.5592 14.1723 24.5592 13.5677C24.5592 12.963 24.069 12.4728 23.4644 12.4728C22.8597 12.4728 22.3695 12.963 22.3695 13.5677C22.3695 14.1723 22.8597 14.6625 23.4644 14.6625Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIconSquare1);
export default __webpack_public_path__ + "static/media/Social Media Icon Square (1).d77bebfa58674548a993c467798b4ca4.svg";
export { ForwardRef as ReactComponent };